// extracted by mini-css-extract-plugin
export default {"edit-modal-wrapper":"edit-modal-wrapper-tn_eZ","editModalWrapper":"edit-modal-wrapper-tn_eZ","inner":"inner-NR0ni","footer":"footer-gzMR4"};